new Splide( '#heroNews',{
    perPage: 3,
    perMove: 1,
    trimSpace: false,
    pagination: false,
    arrows: false,
    gap: '1rem',
    autoplay  : false,
    interval  : 1000,
    breakpoints: {
        1170: {
            perPage: 2,
            padding: { right: '4rem', left: '1rem'},
            gap: 0,
            pagination: true,
        },
        800: {
            perPage: 1,
            padding: { right: '4rem', left: '1rem' },
            gap: 0,
            pagination: true,
        },
    },

} ).mount();
//# sourceMappingURL=splide-control-hero.js.map
